module.exports = __webpack_public_path__ + "static/img/logo.ff26de3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 181
// module chunks = 1